// Shared validation patterns so every form enforces the same rules
// None of these carry the global flag, so the instances are safe to reuse

// Letters, spaces and the punctuation real names carry, so digits are rejected
export const NAME_PATTERN = /^\p{L}[\p{L}\s.'-]*$/u;

export const DIGITS_ONLY_PATTERN = /^\d+$/;

// US phone numbers stored without formatting or country code
export const PHONE_10_DIGIT_PATTERN = /^\d{10}$/;

export const NAME_PATTERN_MESSAGE = 'Name can only contain letters, spaces, apostrophes, hyphens and periods';

export const DIGITS_ONLY_MESSAGE = 'Only digits are allowed';

export const PHONE_10_DIGIT_MESSAGE = 'Phone Number must be numeric and exactly 10 digits long';
